import React, { useContext } from 'react'
import AmexLogo from 'assets/images/amexlogo.svg'

import { useStyles } from 'styles/styles'
import AppContext from 'components/app/AppContext'

interface AppHeaderProps {
}

const AppHeader: React.FC<AppHeaderProps> = (props) => {
    const classes = useStyles()
    const appContext = useContext(AppContext)
    
    const handleLogoClick = () => {
        appContext.onNavigate(0)
    }

    return (
        <img className={classes.logo} src={AmexLogo} alt="AMEX Logo" onClick={handleLogoClick}/>
    )
}

export default AppHeader
